export const SPONSORSHIP_ENDPOINTS = {
  LIST: "sponsorship_requests",
  CREATE: "sponsorship_requests",
  CURRENT_CAMPAIGN: "sponsorship_campaigns/current",
  BALANCE: "sponsorship_points/balance",
  REDEMPTIONS: "sponsorship_redemptions",
  TERMS_CURRENT: "sponsorship_terms/current",
  TERMS_ACCEPT: (termId: string) => `sponsorship_terms/${termId}/accept`,
} as const;
